export default __webpack_public_path__ + "static/media/crossSmallIcon.db8916f4.svg";